module.exports = __webpack_public_path__ + "img/Rusty Glover.b2e42423.jpg";